import { useContext } from "react"
import { publishEvent } from "source/shared/productAnalytics"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { useSession } from "./useSession"

export default function useProductAnalyticsPublishEvent() {
  const { current_organization, product_analytics } =
    useContext(ServerRenderedProps)
  const { data: current_person } = useSession()

  return (eventName: string, payload: object = {}) =>
    publishEvent(
      `church-center.web.${eventName}`,
      {
        organization_id: current_organization.id,
        current_person_id: current_person?.id ?? "Unknown",
        ...payload,
      },
      product_analytics,
    )
}
